export default "__VITE_ASSET__DoLDSoSN__"